import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ObjectTemplateDTO, ObjectTemplateParams } from 'src/app/shared/models/iCourrier/object-template/object-template';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ObjectsTemplatesService {
  private iCourrierURL: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  public fetchObjectTemplate(serviceId?: number): Observable<ObjectTemplateDTO[]> {
    if (serviceId) return this.http.get<ObjectTemplateDTO[]>(`${this.iCourrierURL}/Global/ModelesObjets?serviceId=${serviceId}`);
    return this.http.get<ObjectTemplateDTO[]>(`${this.iCourrierURL}/Global/ModelesObjets`);
  }

  public postModelesObjets(data: ObjectTemplateParams): Observable<ObjectTemplateDTO> {
    return this.http.post<ObjectTemplateDTO>(`${this.iCourrierURL}/Management/ModelesObjets`, data);
  }
}
